import { Box, Container, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import InputTextfield from "../../../../shared/components/textField";
import useMutation from "../../../../shared/components/hooks/useMutation";
import { getValidationSchema } from "../../../../shared/validations/schema";
import MenuContainer from "../../../../shared/components/auth/menuContainer";
import { styled } from "@mui/material/styles";
import LoginLine from "../../../../assets/img/login-line.svg";

const StyledMenuBg = styled(Box)(
  ({ theme }) => `
    top: 0;
    background: transparent;
    padding: 0 10%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
    color: rgba(15, 41, 85, 0.20);
    font-family: Poppins;
    font-size: 50px;
    font-style: normal;
    font-weight: 275;
    line-height: normal;
    margin-top: 0;
    }.
     img {
      max-width: 100%;
      height: auto;
      display: block;
    }
  `
);

const ForgotPassword = () => {
  const { loading, modifyData } = useMutation();

  const textFields = [
    {
      id: "email",
      name: "email",
      label: "Email Address",
      placeholder: "Enter your email",
      required: true,
      type: "text",
    },
  ];

  const forgotPasswordForm = useFormik({
    initialValues: {
      email: "",
    },
    validateOnBlur: true,
    validationSchema: getValidationSchema(["email"]),
    onSubmit: async (formData: any) => {
      const response = await modifyData(
        `/sendPasswordResetLink`,
        "post",
        formData
      );
      if (response) forgotPasswordForm.resetForm();
    },
  });

  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        <Container>
          <Grid
            container
            sx={{
              justifyContent: "center",
              alignItems: "end",
              padding: "24px",
              marginTop: "12%",
            }}
          >
            <Grid item md={4}>
              <MenuContainer />
              <StyledMenuBg>
                <h2>Forgot Password</h2>
              </StyledMenuBg>
            </Grid>
              <Grid item md={0.75}>
              <img style={{ padding: "0 12px" }} src={LoginLine} alt="Logo" />
            </Grid>
            <Grid item md={3.5}>
              <form
                onSubmit={forgotPasswordForm.handleSubmit}
                autoComplete="off"
              >
                <InputTextfield
                  form={forgotPasswordForm}
                  fieldProps={textFields[0]}
                />
                <Grid
                  container
                  sx={{
                    justifyContent: "end",
                    alignItems: "end",
                  }}
                >
                  <Grid item md={3} sx={{ mt: 2 }}>
                    <LoadingButton
                      loading={loading}
                      variant="contained"
                      type="submit"
                      fullWidth
                      size="small"
                    >
                      Submit
                    </LoadingButton>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ForgotPassword;
